import React from "react";
import { Container, Col, Row } from 'react-bootstrap';

function CompanyDescription(props) {
  return (
    <Container fluid className="resume-company">
      <Row xs={2} md={4} lg={6}>
        <Col><img src={props.companyLogo} alt="Beroomers" className="img-fluid resume-company-logo" /></Col>
        <Col lg={10}><h3 className="resume-company-title">{props.company}</h3></Col>
      </Row>
    </Container>
  );
}

export default CompanyDescription;
